import React, { useState, useEffect } from 'react';
import './FilterModal.css';
import { IoMdCloseCircle } from 'react-icons/io';

const InvoiceFilterModal = ({ isOpen, onClose, onApplyFilters, onClearFilters, initialFilters }) => {
  const [filters, setFilters] = useState({ startDate: '', endDate: '' });
  const [expandedDate, setExpandedDate] = useState(false);

  useEffect(() => {
    if (isOpen && initialFilters) {
      setFilters(initialFilters);
      setExpandedDate(!!(initialFilters.startDate || initialFilters.endDate));
    }
  }, [initialFilters, isOpen]);

  const hasActiveFilters = filters.startDate || filters.endDate;

  const handleClearAll = () => {
    setFilters({ startDate: '', endDate: '' });
    setExpandedDate(false);
    onClearFilters();
    onClose();
  };

  const handleApply = () => {
    onApplyFilters(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="filter-modal-overlay" onClick={onClose}>
      <div className="filter-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="filter-modal-header">
          <h2 className="filter-modal-title">Filters</h2>
          <div className="filter-modal-actions">
            <button className="filter-clear-button" onClick={handleClearAll} disabled={!hasActiveFilters}>
              Clear Filter
            </button>
            <button className="filter-apply-button" onClick={handleApply}>
              Apply Filter
            </button>
          </div>
          <IoMdCloseCircle onClick={onClose} size={18} color="brown" className="drawer_close_icon" />
        </div>

        <div className="filter-modal-content">
          <div className="filter-accordion">
            <div className="filter-accordion-header" onClick={() => setExpandedDate(v => !v)}>
              <span>Invoice Date</span>
              <span className="filter-accordion-icon">{expandedDate ? '−' : '+'}</span>
            </div>
            {expandedDate && (
              <div className="filter-accordion-content">
                <div className="filter-date-row">
                  <div className="filter-date-field">
                    <label>From</label>
                    <input
                      type="date"
                      value={filters.startDate}
                      onChange={(e) => setFilters(prev => ({ ...prev, startDate: e.target.value }))}
                      className="filter-date-input"
                    />
                  </div>
                  <div className="filter-date-field">
                    <label>To</label>
                    <input
                      type="date"
                      value={filters.endDate}
                      onChange={(e) => setFilters(prev => ({ ...prev, endDate: e.target.value }))}
                      className="filter-date-input"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFilterModal;
